import { useState } from "react";
import {Link} from "react-router-dom";
import ReactSlider from "react-slider"
import './ContinuousCelebrity.css';
import "../Common.css"

import useScript from '../useScript';

function ContinuousCelebrity()
{
    useScript('../js/continuous.js');
    //useScript('../js/mosaic.js');

    //let zoomSpeed = 0;
    const [zoomSpeed, setZoomSpeed] = useState(1.0);

    return (
        <div className="top-buffer">
            <p>Continuous Celebrity</p>
            <div id="continuousMosaic"></div>
            <ReactSlider
                min={1.0}
                max={1.05}
                step={0.0001}
                defaultValue={1.0}
                onChange={(newValue) => { setZoomSpeed(newValue)} }
                className="horizontal-slider"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
            />
            <Link to="/Mosaics" className="logo"></Link>

            <input id="hdnZoomSpeed" type='hidden' value={zoomSpeed} />
        </div>

    )
}

export default ContinuousCelebrity;